import React from "react";

// reactstrap components
import {
  Alert,
  Badge,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  TabContent,
  TabPane,
} from "reactstrap";
import NumberFormat from 'react-number-format';
// core components
import ShoppingTable from "components/Tables/Shopping";
import Header from "components/Headers/ShoppingHeader";
import ShoppingDetailModal from "components/Modals/ShoppingDetail";
import ShoppingDataService from "../../services/ShoppingDataService";
import ProductDataService from "../../services/ProductDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatPriceInput = (value) => {
  const raw = String(value ?? '').replace(/,/g, '');
  if (raw === '') return '';
  return Number(raw).toLocaleString();
};

const parsePriceInput = (value) => Number(String(value ?? '').replace(/,/g, '')) || 0;

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: 1,
      shoppingList: [],
      perPage: 10,
      currentPage: 1,
      detailModal: false,
      currentShopping: {},
      shoppingId: undefined,
      searchValue: '',
      searchMode: 'nama',
      products: [],
      quantities: {},
      draftItems: [],
      submitting: false,
      cartItems: [],
      cartLoading: false,
      cartStatus: undefined,
      deletingProductId: undefined,
      deleteConfirmModal: false,
      itemToDelete: null,
      submitConfirmModal: false,
      proceedConfirmModal: false,
      proceedTarget: null,
      proceeding: false,
      toastMessage: undefined,
      errorProducts: [],
      cartPanelOpen: false,
      cartBump: false,
      warehouses: [],
      warehouseId: localStorage.getItem('warehouse_id') || '',
      cartEditModal: false,
      cartEditTarget: null,
      cartEditQuantity: '',
      cartEditPrice: '',
      cartEditSellPrice: '',
      cartEditError: undefined,
      priceEditedProductIds: [],
    };
    this.ShoppingDataService = new ShoppingDataService();
    this.ProductDataService = new ProductDataService();
    this.warehouseDataService = new WarehouseDataService();
  }

  componentDidMount() {
    this.fetchShoppingList()
    this.fetchWarehouses()
  }

  fetchWarehouses() {
    this.warehouseDataService.getList(1, 99999, null)
      .then((data) => {
        this.setState({
          warehouses: data.data?.warehouse_list && data.data?.errorMessage === undefined
            ? data.data.warehouse_list
            : [],
        });
      });
  }

  fetchShoppingList() {
    this.ShoppingDataService.getShoppingList(this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  toggleNavs = (e, state, index) => {
    e.preventDefault();
    if (index === 2) {
      this.setState({
        [state]: index,
        shoppingId: undefined,
        cartStatus: undefined,
        quantities: {},
        draftItems: [],
        cartItems: [],
        errorProducts: [],
        products: [],
        searchValue: '',
        searchMode: 'nama',
        cartPanelOpen: false,
        warehouseId: localStorage.getItem('warehouse_id') || '',
        priceEditedProductIds: [],
      }, () => {
        this.loadOpenCart();
      });
    } else {
      this.setState({ [state]: index }, () => {
        this.fetchShoppingList();
      });
    }
  };

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
      currentPage: selectedPage,
    }, () => {
      this.fetchShoppingList()
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  handleSearch = (e) => {
    const keyword = e.target.value;
    this.setState({ searchValue: keyword });
    if (this.state.searchMode === 'barcode') {
      this.fetchProductByBarcode(keyword);
    } else {
      this.fetchProducts(keyword);
    }
  }

  setSearchMode = (mode) => {
    if (mode === this.state.searchMode) {
      return;
    }
    this.setState({
      searchMode: mode,
      searchValue: '',
      products: [],
    });
  }

  handleSearchKeyUp = (e) => {
    if (e.key !== 'Enter' && e.keyCode !== 13) {
      return;
    }
    if (this.state.searchMode !== 'barcode' || this.isCartLocked()) {
      return;
    }
    const matched = (this.state.products || []).filter(product => product);
    if (matched.length !== 1) {
      return;
    }
    this.addToDraft(matched[0]);
    this.setState({ searchValue: '', products: [] });
  }

  fetchProducts(keyword) {
    if (keyword === undefined || keyword === '') {
      this.setState({ products: [] });
      return;
    }
    this.ProductDataService.getList(keyword, undefined, 1, 20)
      .then(res => this.setState(res));
  }

  fetchProductByBarcode(keyword) {
    if (keyword === undefined || keyword === '') {
      this.setState({ products: [] });
      return;
    }
    this.ProductDataService.getByBarcode(keyword, 1, 20)
      .then(res => this.setState(res));
  }

  getQty(productId) {
    const qty = parseInt(this.state.quantities[productId], 10);
    return qty > 0 ? qty : 1;
  }

  handleQtyChange = (productId, value) => {
    this.setState({
      quantities: {
        ...this.state.quantities,
        [productId]: value,
      },
    });
  }

  showToast = (message) => {
    this.setState({ toastMessage: message });
    clearTimeout(this.toastTimeout);
    this.toastTimeout = setTimeout(() => {
      this.setState({ toastMessage: undefined });
    }, 2500);
  }

  addToDraft = (product) => {
    if (!this.state.warehouseId) {
      this.setState({ errorMessage: 'Pilih warehouse tujuan belanja terlebih dahulu.' });
      setTimeout(() => {
        this.setState({ errorMessage: undefined })
      }, 5000);
      return;
    }

    const quantity = this.getQty(product.product_id);

    this.setState((prevState) => {
      const existingIndex = prevState.draftItems.findIndex((item) => item.product_id === product.product_id);
      let draftItems;
      if (existingIndex >= 0) {
        // Adding the same product again accumulates; use the edit popup to set an exact qty.
        draftItems = prevState.draftItems.map((item, i) =>
          i === existingIndex ? { ...item, quantity: item.quantity + quantity } : item
        );
      } else {
        draftItems = [...prevState.draftItems, {
          product_id: product.product_id,
          product_name: product.product_name,
          price: product.price,
          sell_price: product.sell_price,
          stock_warehouse: product.stock_warehouse,
          quantity,
        }];
      }
      return { draftItems };
    });
    this.showToast(`${product.product_name} ditambahkan ke pilihan`);
    this.bumpCartButton();
  }

  handleWarehouseChange = (e) => {
    this.setState({ warehouseId: e.target.value });
  }

  // The API only accepts warehouse_id while creating the cart, so it is fixed
  // as soon as a shopping record exists on the server.
  isWarehouseLocked() {
    return !!this.state.shoppingId || this.isCartLocked();
  }

  getWarehouseName(warehouseId) {
    const warehouse = (this.state.warehouses || []).find(
      (item) => String(item.warehouse_id) === String(warehouseId)
    );
    return warehouse?.warehouse_name;
  }

  openCartEditModal = (item, source) => {
    if (this.isCartLocked()) {
      return;
    }
    const isDraft = source === 'draft';
    this.setState({
      cartEditModal: true,
      cartEditError: undefined,
      cartEditTarget: {
        source,
        productId: isDraft ? item.product_id : item.ProductId,
        productName: isDraft ? item.product_name : item.ProductName,
      },
      cartEditQuantity: String(isDraft ? item.quantity : item.Quantity),
      cartEditPrice: formatPriceInput(isDraft ? item.price : item.Price),
      cartEditSellPrice: formatPriceInput(isDraft ? item.sell_price : item.SellPrice),
    });
  }

  closeCartEditModal = () => {
    this.setState({ cartEditModal: false, cartEditTarget: null, cartEditError: undefined });
  }

  handleCartEditQuantityChange = (e) => {
    this.setState({ cartEditQuantity: e.target.value, cartEditError: undefined });
  }

  handleCartEditPriceChange = (field, value) => {
    if (String(value).length > 21) {
      this.setState({ cartEditError: 'Input angka melebihi batas maksimal sistem.' });
      return;
    }
    this.setState({ [field]: formatPriceInput(value), cartEditError: undefined });
  }

  saveCartEdit = () => {
    const target = this.state.cartEditTarget;
    if (!target) {
      return;
    }

    const price = parsePriceInput(this.state.cartEditPrice);
    const sellPrice = parsePriceInput(this.state.cartEditSellPrice);
    if (price < 0 || sellPrice < 0) {
      this.setState({ cartEditError: 'Harga tidak boleh negatif.' });
      return;
    }

    // Items already stored server-side only get their price changed here; the new
    // price is sent along with submit belanja, keeping the quantity as it is.
    if (target.source === 'cart') {
      this.setState((prevState) => ({
        cartItems: prevState.cartItems.map((item) => (
          item.ProductId === target.productId
            ? { ...item, Price: price, SellPrice: sellPrice, TotalPrice: item.Quantity * price }
            : item
        )),
        priceEditedProductIds: prevState.priceEditedProductIds.includes(target.productId)
          ? prevState.priceEditedProductIds
          : [...prevState.priceEditedProductIds, target.productId],
        cartEditModal: false,
        cartEditTarget: null,
        cartEditError: undefined,
      }));
      this.showToast(`Harga ${target.productName} diubah, submit belanja untuk menyimpan`);
      return;
    }

    const quantity = parseInt(this.state.cartEditQuantity, 10);
    if (!(quantity > 0)) {
      this.setState({ cartEditError: 'Qty harus lebih dari 0.' });
      return;
    }

    this.setState((prevState) => ({
      draftItems: prevState.draftItems.map((item) => (
        item.product_id === target.productId
          ? { ...item, quantity, price, sell_price: sellPrice }
          : item
      )),
      cartEditModal: false,
      cartEditTarget: null,
      cartEditError: undefined,
    }));
    this.showToast(`${target.productName} diperbarui`);
  }

  hasPendingChanges() {
    return this.state.draftItems.length > 0 || this.state.priceEditedProductIds.length > 0;
  }

  getEditedCartProducts() {
    const draftProductIds = (this.state.draftItems || []).map((item) => item.product_id);
    return (this.state.cartItems || [])
      .filter((item) => this.state.priceEditedProductIds.includes(item.ProductId))
      .filter((item) => !draftProductIds.includes(item.ProductId))
      .map((item) => ({
        product_id: item.ProductId,
        quantity: item.Quantity,
        price: item.Price,
        sell_price: item.SellPrice,
      }));
  }

  bumpCartButton = () => {
    this.setState({ cartBump: false }, () => {
      requestAnimationFrame(() => this.setState({ cartBump: true }));
    });
    clearTimeout(this.cartBumpTimeout);
    this.cartBumpTimeout = setTimeout(() => {
      this.setState({ cartBump: false });
    }, 650);
  }

  removeDraftItem = (productId) => {
    this.setState((prevState) => ({
      draftItems: prevState.draftItems.filter((item) => item.product_id !== productId),
    }));
  }

  getDraftTotal() {
    return (this.state.draftItems || []).reduce((sum, item) => sum + (item.quantity * (item.price || 0)), 0);
  }

  // Only one shopping record can stay open, so entering the cart tab resumes it
  // instead of starting an empty one that the backend would refuse to create.
  loadOpenCart() {
    this.setState({ cartLoading: true });
    this.ShoppingDataService.getShoppingList(1, 100)
      .then((res) => {
        const openShopping = (res.shoppingList || []).find((shopping) => shopping.Status === 'create');
        if (!openShopping) {
          this.setState({ cartLoading: false });
          return;
        }
        this.setState({
          shoppingId: openShopping.Id,
          cartStatus: openShopping.Status,
          cartPanelOpen: true,
        });
        this.fetchCartItems(openShopping.Id);
      })
      .catch(() => {
        this.setState({ cartLoading: false });
      });
  }

  fetchCartItems(shoppingId) {
    if (!shoppingId) {
      return;
    }
    this.setState({ cartLoading: true });
    this.ShoppingDataService.getShoppingProductList(shoppingId, 1, 100)
      .then((res) => {
        this.setState({
          cartItems: res.productList || [],
          cartStatus: res.status,
          cartLoading: false,
          warehouseId: res.warehouseId ? String(res.warehouseId) : this.state.warehouseId,
        });
      });
  }

  isCartLocked() {
    return this.state.cartStatus === 'proceed';
  }

  getCartTotal() {
    return (this.state.cartItems || []).reduce((sum, item) => sum + (item.TotalPrice || 0), 0);
  }

  submitCart = () => {
    if (!this.hasPendingChanges() || this.state.submitting) {
      return;
    }
    if (!this.state.shoppingId && !this.state.warehouseId) {
      this.setState({ errorMessage: 'Pilih warehouse tujuan belanja terlebih dahulu.' });
      setTimeout(() => {
        this.setState({ errorMessage: undefined })
      }, 5000);
      return;
    }

    const draftProducts = this.state.draftItems.map((item) => {
      const product = {
        product_id: item.product_id,
        quantity: item.quantity,
      };
      if (item.price > 0) {
        product.price = item.price;
      }
      if (item.sell_price > 0) {
        product.sell_price = item.sell_price;
      }
      return product;
    });

    const products = [...draftProducts, ...this.getEditedCartProducts()];

    this.setState({ submitting: true });
    this.ShoppingDataService.addToCart(this.state.shoppingId, this.state.warehouseId, products)
      .then((res) => {
        this.setState({ submitting: false });

        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
          setTimeout(() => {
            this.setState({ errorMessage: undefined })
          }, 5000);
          return;
        }

        const shoppingId = res.shoppingId || this.state.shoppingId;
        this.setState({
          shoppingId,
          errorProducts: res.errorProducts || [],
          draftItems: [],
          priceEditedProductIds: [],
        });
        this.fetchCartItems(shoppingId);
      });
  }

  dismissErrorProduct = (productId) => {
    this.setState((prevState) => ({
      errorProducts: prevState.errorProducts.filter((item) => item.product_id !== productId),
    }));
  }

  toggleSubmitConfirm = () => {
    this.setState((prevState) => ({ submitConfirmModal: !prevState.submitConfirmModal }));
  }

  confirmSubmitCart = () => {
    this.setState({ submitConfirmModal: false });
    this.submitCart();
  }

  toggleDeleteConfirm = (item) => {
    this.setState((prevState) => ({
      deleteConfirmModal: !prevState.deleteConfirmModal,
      itemToDelete: item || null,
    }));
  }

  confirmRemoveCartItem = () => {
    const item = this.state.itemToDelete;
    this.setState({ deleteConfirmModal: false, itemToDelete: null });
    this.removeCartItem(item);
  }

  removeCartItem = (item) => {
    if (!item || this.state.deletingProductId) {
      return;
    }
    this.setState({ deletingProductId: item.ProductId });
    this.ShoppingDataService.deleteProduct(this.state.shoppingId, [item.ProductId])
      .then((res) => {
        this.setState({ deletingProductId: undefined });

        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
          setTimeout(() => {
            this.setState({ errorMessage: undefined })
          }, 5000);
          return;
        }

        const deletedProductIds = res.deletedProductIds || [];
        this.setState((prevState) => ({
          cartItems: prevState.cartItems.filter((cartItem) => !deletedProductIds.includes(cartItem.ProductId)),
        }));
      });
  }

  toggleProceedConfirm = (shopping) => {
    this.setState((prevState) => ({
      proceedConfirmModal: !prevState.proceedConfirmModal,
      proceedTarget: shopping || null,
    }));
  }

  confirmProceedCart = () => {
    const target = this.state.proceedTarget;
    if (!target || this.state.proceeding) {
      return;
    }
    this.setState({ proceeding: true });
    this.ShoppingDataService.proceedShopping(target.Id)
      .then((res) => {
        this.setState({ proceeding: false, proceedConfirmModal: false, proceedTarget: null });

        if (res.errorMessage) {
          this.setState({ errorMessage: res.errorMessage });
          setTimeout(() => {
            this.setState({ errorMessage: undefined })
          }, 5000);
          return;
        }

        if (this.state.shoppingId === target.Id) {
          this.setState({ cartStatus: res.status || 'proceed' });
        }
        this.showToast('Keranjang berhasil diproses');
        this.fetchShoppingList();
      });
  }

  toggleDetailModal = (shopping) => {
    this.setState({
      detailModal: !this.state.detailModal,
      currentShopping: shopping || {},
    });
  }

  handleEditShopping = (shopping) => {
    this.setState({
      tabs: 2,
      shoppingId: shopping.Id,
      cartStatus: shopping.Status,
      quantities: {},
      draftItems: [],
      cartItems: [],
      errorProducts: [],
      products: [],
      searchValue: '',
      searchMode: 'nama',
      cartPanelOpen: true,
      priceEditedProductIds: [],
    });
    this.fetchCartItems(shopping.Id);
  }

  toggleCartPanel = () => {
    this.setState((prevState) => ({ cartPanelOpen: !prevState.cartPanelOpen }));
  }

  getCartBadgeCount() {
    return (this.state.draftItems?.length || 0) + (this.state.cartItems?.length || 0);
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const renderPageNumbers = pageNumbers.map(number => {
      return (
        <PaginationItem className={this.state.currentPage === number ? "active" : ""}>
          <PaginationLink
            onClick={() => this.handlePageClick(number)}
          >
            {number}
          </PaginationLink>
        </PaginationItem>
      )
    })

    return (
      <>
        <Header tabs={this.state.tabs} toggleNavs={this.toggleNavs} />

        {this.state.toastMessage && (
          <div
            className="bg-gradient-success text-white shadow rounded d-flex align-items-center px-4 py-3"
            style={{
              position: 'fixed',
              top: '24px',
              right: '24px',
              zIndex: 1060,
              minWidth: '260px',
            }}
          >
            <i className="fas fa-check-circle mr-2" />
            <span>{this.state.toastMessage}</span>
          </div>
        )}

        <Container className="mt--7" fluid>
          {this.state.errorMessage && (
            <Row>
              <Col xs="12">
                <Alert color="danger">
                  {this.state.errorMessage}
                </Alert>
              </Col>
            </Row>
          )}
          <TabContent activeTab={"tabs" + this.state.tabs}>
            <TabPane tabId="tabs1">
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row className="align-items-center">
                        <Col xs="8">
                          <h3 className="mb-0">Daftar Belanja</h3>
                        </Col>
                      </Row>
                    </CardHeader>
                    <ShoppingTable
                      shoppingList={this.state.shoppingList}
                      onPreview={this.toggleDetailModal}
                      onEdit={this.handleEditShopping}
                      onProceed={this.toggleProceedConfirm}
                    />
                    <CardFooter className="py-4">
                      {this.state.totalPages > 1 && (
                        <nav aria-label="...">
                          <Pagination
                            className="pagination justify-content-end mb-0"
                            listClassName="justify-content-end mb-0"
                          >
                            <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                              <PaginationLink
                                onClick={() => this.handlePreviousPageClick()}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-left" />
                                <span className="sr-only">Previous</span>
                              </PaginationLink>
                            </PaginationItem>
                            {renderPageNumbers}
                            <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                              <PaginationLink
                                onClick={() => this.handleNextPageClick()}
                              >
                                <i className="fas fa-angle-right" />
                                <span className="sr-only">Next</span>
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </nav>
                      )}
                    </CardFooter>
                  </Card>
                </div>
              </Row>
            </TabPane>
            <TabPane tabId="tabs2">
              <Row>
                <Col xs="12">
                  {this.isCartLocked() && (
                    <Alert color="secondary" className="d-flex align-items-center">
                      <i className="fas fa-lock mr-2" />
                      Keranjang ini sudah diproses dan tidak bisa diubah lagi.
                    </Alert>
                  )}
                  <Card className="shadow">
                    <CardHeader className="border-0">
                      <Row>
                        <Col xs="12" md="6" className="mt-3">
                          <FormGroup>
                            <label className="form-control-label">
                              Warehouse tujuan belanja <sup className="text-red text-sm">*</sup>
                            </label>
                            <Input
                              className="form-control-alternative"
                              type="select"
                              value={this.state.warehouseId}
                              disabled={this.isWarehouseLocked()}
                              onChange={this.handleWarehouseChange}
                            >
                              <option value="">Pilih warehouse</option>
                              {(this.state.warehouses || []).map((warehouse) => (
                                <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                  {warehouse.warehouse_name}
                                </option>
                              ))}
                            </Input>
                            <small className="text-muted">
                              {this.isWarehouseLocked()
                                ? 'Warehouse terkunci karena keranjang sudah dibuat. Proses atau kosongkan keranjang untuk ganti warehouse.'
                                : 'Warehouse dikunci setelah produk pertama masuk ke keranjang.'}
                            </small>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" className="mt-3 align-items-right">
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-4 flex-nowrap">
                              <InputGroupAddon addonType="prepend">
                                <ButtonGroup>
                                  <Button
                                    type="button"
                                    color="primary"
                                    outline={this.state.searchMode !== 'nama'}
                                    disabled={this.isCartLocked()}
                                    onClick={() => this.setSearchMode('nama')}
                                  >
                                    Nama Produk
                                  </Button>
                                  <Button
                                    type="button"
                                    color="primary"
                                    outline={this.state.searchMode !== 'barcode'}
                                    disabled={this.isCartLocked()}
                                    onClick={() => this.setSearchMode('barcode')}
                                  >
                                    Barcode
                                  </Button>
                                </ButtonGroup>
                              </InputGroupAddon>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className={this.state.searchMode === 'barcode' ? 'ni ni-tag' : 'ni ni-zoom-split-in'} />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                className="form-control-alternative"
                                placeholder={this.state.searchMode === 'barcode' ? 'Scan atau ketik barcode' : 'Search produk'}
                                onChange={this.handleSearch}
                                onKeyUp={this.handleSearchKeyUp}
                                name="searchValue"
                                value={this.state.searchValue}
                                disabled={this.isCartLocked()}
                                type="text"
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardHeader>

                    {this.state.errorProducts?.length > 0 && (
                      <CardBody className="pt-0">
                        {this.state.errorProducts.map((errorProduct) => (
                          <Alert
                            color="warning"
                            key={errorProduct.product_id}
                            toggle={() => this.dismissErrorProduct(errorProduct.product_id)}
                          >
                            <b>{errorProduct.product_name}</b>: {errorProduct.error_message}
                          </Alert>
                        ))}
                      </CardBody>
                    )}

                    {this.state.products != null && this.state.products.filter(product => product).length > 0 && (
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">Nama produk</th>
                            <th scope="col">Harga beli</th>
                            <th scope="col">Harga jual</th>
                            <th scope="col">Stok warehouse</th>
                            <th scope="col">Qty</th>
                            <th scope="col" />
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.products.filter(product => product).map((product) => (
                            <tr key={product.product_id}>
                              <th scope="row">{product.product_name}</th>
                              <td>
                                <NumberFormat
                                  value={product.price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="Rp."
                                  suffix=",00" />
                              </td>
                              <td>
                                <NumberFormat
                                  value={product.sell_price}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="Rp."
                                  suffix=",00" />
                              </td>
                              <td>{product.stock_warehouse}</td>
                              <td>
                                <Input
                                  className="form-control-alternative"
                                  type="number"
                                  min="1"
                                  disabled={this.isCartLocked()}
                                  style={{ width: '80px' }}
                                  value={this.state.quantities[product.product_id] ?? 1}
                                  onChange={(e) => this.handleQtyChange(product.product_id, e.target.value)}
                                />
                              </td>
                              <td>
                                <Button
                                  color="primary"
                                  size="sm"
                                  disabled={this.isCartLocked() || !this.state.warehouseId}
                                  onClick={() => this.addToDraft(product)}
                                >
                                  Tambah
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Card>
                </Col>
              </Row>

              <style>{`
                @keyframes shopping-cart-bump {
                  0% { transform: scale(1); }
                  35% { transform: scale(1.25); }
                  60% { transform: scale(0.95); }
                  100% { transform: scale(1); }
                }
                .shopping-cart-button.cart-bump {
                  animation: shopping-cart-bump 0.5s ease-out;
                }
              `}</style>

              {/* Floating cart button */}
              <Button
                color="primary"
                className={`shopping-cart-button rounded-circle shadow d-flex align-items-center justify-content-center${this.state.cartBump ? ' cart-bump' : ''}`}
                onClick={this.toggleCartPanel}
                style={{
                  position: 'fixed',
                  bottom: '24px',
                  right: '24px',
                  width: '56px',
                  height: '56px',
                  padding: 0,
                  zIndex: 1050,
                }}
              >
                <i className="fas fa-shopping-cart" style={{ marginRight: 0 }} />
                {this.getCartBadgeCount() > 0 && (
                  <Badge
                    pill
                    style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      backgroundColor: '#f5365c',
                      color: '#fff',
                    }}
                  >
                    {this.getCartBadgeCount()}
                  </Badge>
                )}
              </Button>

              {this.state.cartPanelOpen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '560px',
                    maxWidth: '100%',
                    height: '100vh',
                    overflowY: 'auto',
                    zIndex: 1049,
                    backgroundColor: '#f8f9fe',
                    boxShadow: '-4px 0 16px rgba(0,0,0,0.15)',
                  }}
                >
                  <div className="bg-gradient-info px-4 py-4 d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-white ls-1 mb-1 opacity-8">Keranjang Belanja</h6>
                      <h2 className="text-white mb-0">
                        <i className="fas fa-shopping-cart mr-2" />
                        {this.getCartBadgeCount()} produk
                      </h2>
                    </div>
                    <button
                      aria-label="Close"
                      className="close text-white"
                      type="button"
                      onClick={this.toggleCartPanel}
                    >
                      <span aria-hidden={true}>&times;</span>
                    </button>
                  </div>

                  <div className="px-4 py-4">
                    <Card className="shadow border-0 mb-4">
                      <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Produk dipilih</h3>
                        {this.state.draftItems.length > 0 && (
                          <span className="badge badge-pill bg-gradient-default text-white">
                            {this.state.draftItems.length}
                          </span>
                        )}
                      </CardHeader>
                      <CardBody className="pt-0">
                        {this.state.draftItems.length === 0 && (
                          <div className="text-center py-4">
                            <i className="fas fa-cart-plus fa-2x text-muted mb-2" />
                            <p className="text-sm text-muted mb-0">Belum ada produk dipilih.</p>
                          </div>
                        )}
                        {this.state.draftItems.length > 0 && (
                          <div className="border rounded" style={{ overflow: 'hidden' }}>
                            <Table className="align-items-center table-flush mb-0" size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                              <colgroup>
                                <col style={{ width: '39%' }} />
                                <col style={{ width: '14%' }} />
                                <col style={{ width: '28%' }} />
                                <col style={{ width: '19%' }} />
                              </colgroup>
                              <thead className="thead-light">
                                <tr>
                                  <th scope="col">Produk</th>
                                  <th scope="col">Qty</th>
                                  <th scope="col">Total</th>
                                  <th scope="col" />
                                </tr>
                              </thead>
                            </Table>
                            <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                              <Table className="align-items-center table-flush mb-0" size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                                <colgroup>
                                  <col style={{ width: '39%' }} />
                                  <col style={{ width: '14%' }} />
                                  <col style={{ width: '28%' }} />
                                  <col style={{ width: '19%' }} />
                                </colgroup>
                                <tbody>
                                  {this.state.draftItems.map((item) => (
                                    <tr key={item.product_id}>
                                      <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                        {item.product_name}
                                        <div className="text-xs text-muted">
                                          Beli{' '}
                                          <NumberFormat
                                            value={item.price}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="Rp." />
                                          {' '}· Jual{' '}
                                          <NumberFormat
                                            value={item.sell_price}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="Rp." />
                                        </div>
                                      </td>
                                      <td>
                                        <span className="badge badge-pill bg-gradient-default text-white">
                                          {item.quantity}
                                        </span>
                                      </td>
                                      <td className="font-weight-bold" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                        <NumberFormat
                                          value={item.quantity * (item.price || 0)}
                                          displayType="text"
                                          thousandSeparator
                                          prefix="Rp."
                                          suffix=",00" />
                                      </td>
                                      <td>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          outline
                                          className="btn-icon-only rounded-circle mr-1"
                                          disabled={this.isCartLocked()}
                                          onClick={() => this.openCartEditModal(item, 'draft')}
                                        >
                                          <i className="fas fa-pen" />
                                        </Button>
                                        <Button
                                          color="danger"
                                          size="sm"
                                          outline
                                          className="btn-icon-only rounded-circle"
                                          disabled={this.isCartLocked()}
                                          onClick={() => this.removeDraftItem(item.product_id)}
                                        >
                                          <i className="fas fa-trash" />
                                        </Button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                            <div className="bg-gradient-secondary border-top px-3 py-2 d-flex justify-content-between align-items-center">
                              <span className="text-uppercase text-xs font-weight-bold text-muted ls-1">Subtotal</span>
                              <span className="h4 mb-0 text-primary">
                                <NumberFormat
                                  value={this.getDraftTotal()}
                                  displayType="text"
                                  thousandSeparator
                                  prefix="Rp."
                                  suffix=",00" />
                              </span>
                            </div>
                          </div>
                        )}
                      </CardBody>
                      <CardFooter className="bg-transparent border-0 pt-0">
                        <Button
                          color="primary"
                          block
                          className="d-flex align-items-center justify-content-center"
                          disabled={!this.hasPendingChanges() || this.state.submitting || this.isCartLocked()}
                          onClick={this.toggleSubmitConfirm}
                        >
                          {this.state.submitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" />
                              Menyimpan...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-check mr-2" />
                              Submit Belanja
                            </>
                          )}
                        </Button>
                      </CardFooter>
                    </Card>

                    {(this.state.cartLoading || this.state.cartItems.length > 0) && (
                      <Card className="shadow border-0">
                        <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                          <h3 className="mb-0">Sudah di keranjang</h3>
                          <div className="d-flex align-items-center">
                            {this.state.cartStatus && (
                              <span className={`badge badge-pill mr-2 text-white ${this.isCartLocked() ? 'bg-gradient-success' : 'bg-gradient-warning'}`}>
                                {this.isCartLocked() ? 'Selesai' : 'Terbuka'}
                              </span>
                            )}
                            {this.state.cartLoading ? (
                              <span className="spinner-border spinner-border-sm text-primary" role="status" />
                            ) : (
                              <span className="badge badge-pill bg-gradient-success text-white">
                                {this.state.cartItems.length}
                              </span>
                            )}
                          </div>
                        </CardHeader>
                        <CardBody className="pt-0">
                          {this.state.cartItems.length > 0 && (
                            <div className="border rounded" style={{ overflow: 'hidden' }}>
                              <Table className="align-items-center table-flush mb-0" size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                                <colgroup>
                                  <col style={{ width: '39%' }} />
                                  <col style={{ width: '14%' }} />
                                  <col style={{ width: '28%' }} />
                                  <col style={{ width: '19%' }} />
                                </colgroup>
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">Produk</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Total</th>
                                    <th scope="col" />
                                  </tr>
                                </thead>
                              </Table>
                              <div style={{ maxHeight: '240px', overflowY: 'auto' }}>
                                <Table className="align-items-center table-flush mb-0" size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                                  <colgroup>
                                    <col style={{ width: '39%' }} />
                                    <col style={{ width: '14%' }} />
                                    <col style={{ width: '28%' }} />
                                    <col style={{ width: '19%' }} />
                                  </colgroup>
                                  <tbody>
                                    {this.state.cartItems.map((item) => (
                                      <tr key={item.Id}>
                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                          {item.ProductName}
                                          <div className="text-xs text-muted">
                                            Beli{' '}
                                            <NumberFormat
                                              value={item.Price}
                                              displayType="text"
                                              thousandSeparator
                                              prefix="Rp." />
                                            {' '}· Jual{' '}
                                            <NumberFormat
                                              value={item.SellPrice}
                                              displayType="text"
                                              thousandSeparator
                                              prefix="Rp." />
                                          </div>
                                          {this.state.priceEditedProductIds.includes(item.ProductId) && (
                                            <span className="badge badge-pill bg-gradient-warning text-white">
                                              Harga belum disimpan
                                            </span>
                                          )}
                                        </td>
                                        <td>
                                          <span className="badge badge-pill bg-gradient-success text-white">
                                            {item.Quantity}
                                          </span>
                                        </td>
                                        <td className="font-weight-bold" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                          <NumberFormat
                                            value={item.TotalPrice}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="Rp."
                                            suffix=",00" />
                                        </td>
                                        <td>
                                          {!this.isCartLocked() && (
                                            <>
                                              <Button
                                                color="primary"
                                                size="sm"
                                                outline
                                                className="btn-icon-only rounded-circle mr-1"
                                                onClick={() => this.openCartEditModal(item, 'cart')}
                                              >
                                                <i className="fas fa-pen" />
                                              </Button>
                                              <Button
                                                color="danger"
                                                size="sm"
                                                outline
                                                className="btn-icon-only rounded-circle"
                                                disabled={this.state.deletingProductId === item.ProductId}
                                                onClick={() => this.toggleDeleteConfirm(item)}
                                              >
                                                {this.state.deletingProductId === item.ProductId ? (
                                                  <span className="spinner-border spinner-border-sm" role="status" />
                                                ) : (
                                                  <i className="fas fa-trash" />
                                                )}
                                              </Button>
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                              <div className="bg-gradient-secondary border-top px-3 py-2 d-flex justify-content-between align-items-center">
                                <span className="text-uppercase text-xs font-weight-bold text-muted ls-1">Subtotal</span>
                                <span className="h4 mb-0 text-success">
                                  <NumberFormat
                                    value={this.getCartTotal()}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="Rp."
                                    suffix=",00" />
                                </span>
                              </div>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    )}
                  </div>
                </div>
              )}
            </TabPane>
          </TabContent>
        </Container>
        <ShoppingDetailModal
          formModal={this.state.detailModal}
          toggleModal={() => this.toggleDetailModal()}
          currentShopping={this.state.currentShopping}
        />

        <Modal
          className="modal-dialog-centered modal-danger"
          contentClassName="bg-gradient-danger"
          isOpen={this.state.deleteConfirmModal}
          toggle={() => this.toggleDeleteConfirm()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleDeleteConfirm()}
            >
              <span aria-hidden={true}>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className="ni ni-bell-55 ni-4x" />
              <h4 className="heading mt-4">Hapus produk dari keranjang?</h4>
              <p>
                Produk <b>{this.state.itemToDelete?.ProductName}</b> akan dihapus dari keranjang belanja ini.
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="text-white ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleDeleteConfirm()}
            >
              Batal
            </Button>
            <Button
              className="btn-white"
              color="default"
              type="button"
              onClick={this.confirmRemoveCartItem}
            >
              Ya, Hapus
            </Button>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-primary"
          contentClassName="bg-gradient-primary"
          isOpen={this.state.submitConfirmModal}
          toggle={this.toggleSubmitConfirm}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleSubmitConfirm}
            >
              <span aria-hidden={true}>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className="fas fa-shopping-cart fa-3x" />
              <h4 className="heading mt-4">Submit belanja ini?</h4>
              <p>
                {this.state.draftItems.length > 0 && (
                  <>
                    {this.state.draftItems.length} produk senilai{' '}
                    <NumberFormat
                      value={this.getDraftTotal()}
                      displayType="text"
                      thousandSeparator
                      prefix="Rp."
                      suffix=",00" />
                    {' '}akan disubmit ke keranjang belanja
                    {this.getWarehouseName(this.state.warehouseId)
                      ? <> di warehouse <b>{this.getWarehouseName(this.state.warehouseId)}</b></>
                      : null}.
                    <br />
                  </>
                )}
                {this.getEditedCartProducts().length > 0 && (
                  <>
                    Perubahan harga beli/jual pada {this.getEditedCartProducts().length} produk yang
                    sudah ada di keranjang juga akan dikirim.
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="text-white ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleSubmitConfirm}
            >
              Batal
            </Button>
            <Button
              className="btn-white"
              color="default"
              type="button"
              onClick={this.confirmSubmitCart}
            >
              Ya, Submit
            </Button>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-warning"
          contentClassName="bg-gradient-warning"
          isOpen={this.state.proceedConfirmModal}
          toggle={this.toggleProceedConfirm}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleProceedConfirm}
            >
              <span aria-hidden={true}>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              <i className="fas fa-arrow-circle-right fa-3x" />
              <h4 className="heading mt-4">Proses keranjang belanja ini?</h4>
              <p>
                {this.state.proceedTarget && (
                  <>
                    Yakin ingin memproses keranjang tanggal <b>{formatDate(this.state.proceedTarget.ShoppingDate)}</b> ({this.state.proceedTarget.TotalItem} item)?
                    <br />
                  </>
                )}
                Setelah diproses, keranjang tidak bisa diubah atau dibatalkan.
                <br />
                Stok warehouse akan ditambah dan <b>harga master produk akan diperbarui</b> mengikuti harga beli dan harga jual di keranjang ini.
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="text-white ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleProceedConfirm}
            >
              Batal
            </Button>
            <Button
              className="btn-white"
              color="default"
              type="button"
              onClick={this.confirmProceedCart}
            >
              Ya, Proses
            </Button>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.cartEditModal}
          toggle={this.closeCartEditModal}
        >
          <div className="modal-header">
            <h4 className="modal-title">Ubah Qty &amp; Harga</h4>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.closeCartEditModal}
            >
              <span aria-hidden={true}>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <h5 className="mb-3">{this.state.cartEditTarget?.productName}</h5>

            {this.state.cartEditError && (
              <Alert color="danger" className="py-2 px-3">
                {this.state.cartEditError}
              </Alert>
            )}

            {this.state.cartEditTarget?.source === 'cart' && (
              <Alert color="info" className="py-2 px-3">
                <i className="fas fa-info-circle mr-2" />
                Produk ini sudah tersimpan di keranjang. Harga baru dikirim bersama
                <b> Submit Belanja</b>, dan qty-nya tetap seperti sekarang.
              </Alert>
            )}

            <FormGroup>
              <label className="form-control-label">Qty</label>
              <Input
                className="form-control-alternative"
                type="number"
                min="1"
                disabled={this.state.cartEditTarget?.source === 'cart'}
                value={this.state.cartEditQuantity}
                onChange={this.handleCartEditQuantityChange}
              />
            </FormGroup>
            <FormGroup>
              <label className="form-control-label">Harga beli</label>
              <Input
                className="form-control-alternative"
                type="text"
                placeholder="Harga beli produk"
                value={this.state.cartEditPrice}
                onChange={(e) => this.handleCartEditPriceChange('cartEditPrice', e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <label className="form-control-label">Harga jual</label>
              <Input
                className="form-control-alternative"
                type="text"
                placeholder="Harga jual produk"
                value={this.state.cartEditSellPrice}
                onChange={(e) => this.handleCartEditPriceChange('cartEditSellPrice', e.target.value)}
              />
            </FormGroup>
          </div>
          <div className="modal-footer">
            <Button
              color="link"
              className="ml-auto"
              type="button"
              onClick={this.closeCartEditModal}
            >
              Batal
            </Button>
            <Button
              color="primary"
              type="button"
              onClick={this.saveCartEdit}
            >
              Simpan
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}

export default List;
